module.exports = __webpack_public_path__ + "static/media/navbar-ico-3.6205afda.svg";